"use strict";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function removeXHRPromise(e) {
  return e.then = null, e.promise = null, e.catch = null, e;
}function internalRequest(e, t, n, i, s, a) {
  var _this = this;

  return new Promise(function (r, l) {
    requestQueue || (requestQueue = utilities.queue.createQueue());var u = null,
        o = null,
        c = null;if ("function" == typeof a ? u = a : a instanceof utilities.CancellationToken && (c = a).on("canceled", function () {
      o && o();
    }), c && c.isCanceled) l(new utilities.CancellationTokenError());else if (requestQueue.exists(e)) {
      var _t = requestQueue.subscribe(e, function (e, t) {
        t = removeXHRPromise(t), r(t), u && u.call(this, e, t);
      });o = function o() {
        requestQueue.unsubscribe(e, _t), l(new utilities.CancellationTokenError());
      };
    } else {
      var m = utilities.mergeObjects(t.ajaxSettings, { url: n, method: i, async: !0 });if (t.accessTokenSettings && t.accessTokenSettings.headerName) {
        var d = localStorage.getItem(t.accessTokenSettings.storageKey);d && (m.beforeSend = function (e) {
          var n = t.accessTokenSettings.valuePrefix ? t.accessTokenSettings.valuePrefix + " " : "";e.setRequestHeader(t.accessTokenSettings.headerName, n + d);
        });
      }var _a = !1,
          _c = requestQueue.begin(e),
          f = new window.XMLHttpRequest();o = function o() {
        _a = !0, 0 === _c.length && f.abort(), l(new utilities.CancellationTokenError());
      }, utilities.analytics.timing(function (i) {
        return new Promise(function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(o) {
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    m.complete = function (t) {
                      var s = null;4 !== t.readyState ? s = new Error("A network error has occured") : (t.status < 100 || t.status >= 400) && (s = new Error("Server responded with an error status code: " + t.status)), _a || (o(i("Private API", n, t.status)), t = removeXHRPromise(t), s ? l(t) : r(t), u && u(s, t)), requestQueue.end(e, s, t);
                    }, m.data = s, m.data && t.prepareStatement && t.prepareStatement(m), m.xhr = function () {
                      return f;
                    }, _c.on("unsubscribed", function () {
                      0 === _c.length && _a && (o(), f.abort(), l(new utilities.CancellationTokenError()));
                    });_context.prev = 1;
                    _context.next = 4;
                    return setAccessToken(t.accessTokenSettings);

                  case 4:
                    _context.next = 8;
                    break;

                  case 6:
                    _context.prev = 6;
                    _context.t0 = _context["catch"](1);

                  case 8:
                    $.ajax(m);
                  case 9:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, _this, [[1, 6]]);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      });
    }
  });
}function setAccessToken(e) {
  var _this2 = this;

  return new Promise(function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(t, n) {
      var i, s, a, r;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(e && e.system)) {
                _context3.next = 16;
                break;
              }

              i = function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                  var i, s;
                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          i = common._getConfig("microservice_auth");
                          _context2.next = 3;
                          return common._endpoint(i, e.system, {});

                        case 3:
                          s = _context2.sent;
                          return _context2.abrupt("return", internalRequest(utilities.key({ uri: s, method: "get", data: null }), i, s, "get", null, common._wrapJSONXhrCallback(function (i, s) {
                            null === i ? (localStorage.setItem(e.storageKey, s.accessToken.token), t()) : n(i);
                          })));

                        case 5:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, this);
                }));

                return function i() {
                  return _ref3.apply(this, arguments);
                };
              }(), s = localStorage.getItem(e.storageKey);

              if (!s) {
                _context3.next = 12;
                break;
              }

              a = jwt_decode(s), r = Date.now() / 1e3;

              if (!(a && a.exp < r)) {
                _context3.next = 9;
                break;
              }

              _context3.next = 7;
              return i();

            case 7:
              _context3.next = 10;
              break;

            case 9:
              t();

            case 10:
              _context3.next = 14;
              break;

            case 12:
              _context3.next = 14;
              return i();

            case 14:
              _context3.next = 17;
              break;

            case 16:
              t();
            case 17:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this2);
    }));

    return function (_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }());
}var requestQueue,
    requestCache,
    common = require("./common.js"),
    utilities = require("../utilities.js"),
    $ = "undefined" != typeof window ? window.jQuery : "undefined" != typeof global ? global.jQuery : null,
    request = function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(e, t, n, i, s, a) {
    var r;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            e = common._getConfig(e);_context4.next = 3;
            return common._endpoint(e, n, i);

          case 3:
            r = _context4.sent;
            return _context4.abrupt("return", internalRequest(utilities.key({ uri: r, method: t, data: s }), e, r, t, s, a));

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function request(_x4, _x5, _x6, _x7, _x8, _x9) {
    return _ref4.apply(this, arguments);
  };
}();request.cache = function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(e, t, n, i, s, a, r, l, u) {
    var _this3 = this;

    var o;
    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            e = common._getConfig(e);_context7.next = 3;
            return common._endpoint(e, n, i);

          case 3:
            o = _context7.sent;
            return _context7.abrupt("return", new Promise(function () {
              var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(n, i) {
                var c, m, d, f, _e, _t2, _u2;

                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                  while (1) {
                    switch (_context6.prev = _context6.next) {
                      case 0:
                        c = utilities.key({ uri: o, method: t, data: s, extraKey: u });
                        requestCache || (requestCache = utilities.cache.createCache());m = null, d = null, f = null;

                        if (!("function" == typeof a ? m = a : a instanceof utilities.CancellationToken && (f = a).on("canceled", function () {
                          d && d();
                        }), f && f.isCanceled)) {
                          _context6.next = 7;
                          break;
                        }

                        i(new utilities.CancellationTokenError());_context6.next = 26;
                        break;

                      case 7:
                        if (!requestCache.exists(c)) {
                          _context6.next = 12;
                          break;
                        }

                        _e = requestCache.get(c), _t2 = utilities.nextTick(function () {
                          n(_e), m && m.call(this, null, _e);
                        });
                        d = function d() {
                          utilities.nextTickClear(_t2), i(new utilities.CancellationTokenError());
                        };_context6.next = 26;
                        break;

                      case 12:
                        if (!(null != r)) {
                          _context6.next = 16;
                          break;
                        }

                        r.get(c, function () {
                          var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(u) {
                            var _e2, _u;

                            return regeneratorRuntime.wrap(function _callee5$(_context5) {
                              while (1) {
                                switch (_context5.prev = _context5.next) {
                                  case 0:
                                    if (!(null != u)) {
                                      _context5.next = 5;
                                      break;
                                    }

                                    _e2 = utilities.nextTick(function () {
                                      n(u), m && m.call(this, null, u);
                                    });
                                    d = function d() {
                                      utilities.nextTickClear(_e2), i(new utilities.CancellationTokenError());
                                    };_context5.next = 15;
                                    break;

                                  case 5:
                                    _context5.prev = 5;
                                    _context5.next = 8;
                                    return internalRequest(c, e, o, t, s, a);

                                  case 8:
                                    _u = _context5.sent;
                                    requestCache.set(c, _u), r.set(c, _u, l), n(_u);_context5.next = 15;
                                    break;

                                  case 12:
                                    _context5.prev = 12;
                                    _context5.t0 = _context5["catch"](5);
                                    i(_context5.t0);
                                  case 15:
                                  case "end":
                                    return _context5.stop();
                                }
                              }
                            }, _callee5, _this3, [[5, 12]]);
                          }));

                          return function (_x21) {
                            return _ref7.apply(this, arguments);
                          };
                        }());_context6.next = 26;
                        break;

                      case 16:
                        _context6.prev = 16;
                        _context6.next = 19;
                        return internalRequest(c, e, o, t, s, a);

                      case 19:
                        _u2 = _context6.sent;
                        requestCache.set(c, _u2), null != r && r.set(c, _u2, l), n(_u2);_context6.next = 26;
                        break;

                      case 23:
                        _context6.prev = 23;
                        _context6.t0 = _context6["catch"](16);
                        i(_context6.t0);
                      case 26:
                      case "end":
                        return _context6.stop();
                    }
                  }
                }, _callee6, _this3, [[16, 23]]);
              }));

              return function (_x19, _x20) {
                return _ref6.apply(this, arguments);
              };
            }()));

          case 5:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, this);
  }));

  return function (_x10, _x11, _x12, _x13, _x14, _x15, _x16, _x17, _x18) {
    return _ref5.apply(this, arguments);
  };
}(), module.exports = request;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInJlcXVlc3QuanMiXSwibmFtZXMiOlsiY29tbW9uIiwicmVxdWlyZSIsInV0aWxpdGllcyIsIiQiLCJ3aW5kb3ciLCJnbG9iYWwiLCJyZW1vdmVYSFJQcm9taXNlIiwieGhyIiwidGhlbiIsInByb21pc2UiLCJjYXRjaCIsInJlcXVlc3RRdWV1ZSIsImludGVybmFsUmVxdWVzdCIsImtleSIsImNvbmZpZyIsInVyaSIsIm1ldGhvZCIsImRhdGEiLCJjYW5jZWxsYXRpb25Ub2tlbk9yQ2FsbGJhY2siLCJQcm9taXNlIiwicmVzb2x2ZSIsInJlamVjdCIsInF1ZXVlIiwiY3JlYXRlUXVldWUiLCJjYWxsYmFjayIsImNhbmNlbEZ1bmN0aW9uIiwiY3QiLCJDYW5jZWxsYXRpb25Ub2tlbiIsIm9uIiwiaXNDYW5jZWxlZCIsIkNhbmNlbGxhdGlvblRva2VuRXJyb3IiLCJleGlzdHMiLCJxdWV1ZUlkIiwic3Vic2NyaWJlIiwiZXJyb3IiLCJjYWxsIiwidGhpcyIsInVuc3Vic2NyaWJlIiwic2V0dGluZ3MiLCJtZXJnZU9iamVjdHMiLCJhamF4U2V0dGluZ3MiLCJ1cmwiLCJhc3luYyIsImFjY2Vzc1Rva2VuU2V0dGluZ3MiLCJoZWFkZXJOYW1lIiwidG9rZW5WYWx1ZSIsImxvY2FsU3RvcmFnZSIsImdldEl0ZW0iLCJzdG9yYWdlS2V5IiwiYmVmb3JlU2VuZCIsInByZWZpeCIsInZhbHVlUHJlZml4Iiwic2V0UmVxdWVzdEhlYWRlciIsInF1ZXVlT2JqZWN0IiwiYmVnaW4iLCJYTUxIdHRwUmVxdWVzdCIsImxlbmd0aCIsImFib3J0IiwiYW5hbHl0aWNzIiwidGltaW5nIiwibWFrZVN0YXRPYmplY3QiLCJjb21wbGV0ZSIsInJlYWR5U3RhdGUiLCJFcnJvciIsInN0YXR1cyIsInN0YXRSZXNvbHZlIiwiZW5kIiwicHJlcGFyZVN0YXRlbWVudCIsInNldEFjY2Vzc1Rva2VuIiwiYWpheCIsInJlcXVlc3QiLCJwYXRoIiwicGFyYW1ldGVycyIsIl9nZXRDb25maWciLCJfZW5kcG9pbnQiLCJ0b2tlblNldHRpbmdzIiwic3lzdGVtIiwiZ2V0dG9rZW4iLCJtc0NvbmZpZyIsIm1zVXJpIiwiX3dyYXBKU09OWGhyQ2FsbGJhY2siLCJzZXRJdGVtIiwiYWNjZXNzVG9rZW4iLCJ0b2tlbiIsImRlY29kZWQiLCJqd3RfZGVjb2RlIiwiY3VycmVudF90aW1lIiwiRGF0ZSIsIm5vdyIsImV4cCIsInJlcXVlc3RDYWNoZSIsImNhY2hlIiwic3RvcmFnZSIsImV4cGlyYXRpb24iLCJleHRyYUtleSIsImNyZWF0ZUNhY2hlIiwiY2FjaGVkRGF0YSIsImdldCIsIm5leHRUaWNrSWQiLCJuZXh0VGljayIsIm5leHRUaWNrQ2xlYXIiLCJzdG9yZWREYXRhIiwicmVzcG9uc2UiLCJzZXQiLCJtb2R1bGUiLCJleHBvcnRzIl0sIm1hcHBpbmdzIjoiOzs7O0FBT0EsU0FBU00sZ0JBQVQsQ0FBMEJDLENBQTFCLEVBQTBCQTtBQUt0QixTQUpBQSxFQUFJQyxJQUFKRCxHQUFXLElBQVhBLEVBQ0FBLEVBQUlFLE9BQUpGLEdBQWMsSUFEZEEsRUFFQUEsRUFBSUcsS0FBSkgsR0FBWSxJQUZaQSxFQUlPQSxDQUFQO0FBS0osVUFBU0ssZUFBVCxDQUF5QkMsQ0FBekIsRUFBOEJDLENBQTlCLEVBQXNDQyxDQUF0QyxFQUEyQ0MsQ0FBM0MsRUFBbURDLENBQW5ELEVBQXlEQyxDQUF6RCxFQUF5REE7QUFBQUE7O0FBQ3JELFNBQU8sSUFBSUMsT0FBSixDQUFZLFVBQUNDLENBQUQsRUFBVUMsQ0FBVixFQUFVQTtBQUNwQlYscUJBQ0RBLGVBQWVULFVBQVVvQixLQUFWcEIsQ0FBZ0JxQixXQUFoQnJCLEVBRGRTLEVBSUwsSUFBSWEsSUFBVyxJQUFmO0FBQUEsUUFDSUMsSUFBaUIsSUFEckI7QUFBQSxRQUVJQyxJQUFLLElBRlQsQ0FnQkEsSUFaMkMsY0FBQSxPQUFoQ1IsQ0FBZ0MsR0FDdkNNLElBQVdOLENBRDRCLEdBR2xDQSxhQUF1Q2hCLFVBQVV5QixpQkFBakRULElBQWlEUyxDQUN0REQsSUFBS1IsQ0FEaURTLEVBRW5EQyxFQUZtREQsQ0FFaEQsVUFGZ0RBLEVBRXBDLFlBQUE7QUFDVkYsV0FDQUEsR0FEQUE7QUFDQUEsS0FKOENFLENBSGYsRUFZdkNELEtBQU1BLEVBQUdHLFVBQWIsRUFDSVIsRUFBTyxJQUFJbkIsVUFBVTRCLHNCQUFkLEVBQVBULEVBREosS0FLQSxJQUFJVixhQUFhb0IsTUFBYnBCLENBQW9CRSxDQUFwQkYsQ0FBSixFQUE4QjtBQUMxQixVQUFJcUIsS0FBVXJCLGFBQWFzQixTQUFidEIsQ0FBdUJFLENBQXZCRixFQUE0QixVQUFVdUIsQ0FBVixFQUFpQjNCLENBQWpCLEVBQWlCQTtBQUN2REEsWUFBTUQsaUJBQWlCQyxDQUFqQkQsQ0FBTkMsRUFFQWEsRUFBUWIsQ0FBUmEsQ0FGQWIsRUFJSWlCLEtBQ0FBLEVBQVNXLElBQVRYLENBQWNZLElBQWRaLEVBQW9CVSxDQUFwQlYsRUFBMkJqQixDQUEzQmlCLENBTEpqQjtBQUsrQkEsT0FOckJJLENBQWQsQ0FVQWMsSUFBaUIsYUFBQTtBQUNiZCxxQkFBYTBCLFdBQWIxQixDQUF5QkUsQ0FBekJGLEVBQThCcUIsRUFBOUJyQixHQUVBVSxFQUFPLElBQUluQixVQUFVNEIsc0JBQWQsRUFBUFQsQ0FGQVY7QUFFcUJtQixPQUh6Qkw7QUFHeUJLLEtBZDdCLE1BaUJLO0FBQ0QsVUFBSVEsSUFBV3BDLFVBQVVxQyxZQUFWckMsQ0FBdUJZLEVBQU8wQixZQUE5QnRDLEVBQThCc0MsRUFDekNDLEtBQUsxQixDQURvQ3lCLEVBRXpDeEIsUUFBUUEsQ0FGaUN3QixFQUd6Q0UsT0FBQUEsQ0FBTyxDQUhrQ0YsRUFBOUJ0QyxDQUFmLENBS0EsSUFBSVksRUFBTzZCLG1CQUFQN0IsSUFBOEJBLEVBQU82QixtQkFBUDdCLENBQTJCOEIsVUFBN0QsRUFBeUU7QUFDckUsWUFBSUMsSUFBYUMsYUFBYUMsT0FBYkQsQ0FBcUJoQyxFQUFPNkIsbUJBQVA3QixDQUEyQmtDLFVBQWhERixDQUFqQixDQUNJRCxNQUNBUCxFQUFTVyxVQUFUWCxHQUFzQixVQUFVL0IsQ0FBVixFQUFVQTtBQUM1QixjQUFJMkMsSUFBU3BDLEVBQU82QixtQkFBUDdCLENBQTJCcUMsV0FBM0JyQyxHQUF5Q0EsRUFBTzZCLG1CQUFQN0IsQ0FBMkJxQyxXQUEzQnJDLEdBQXlDLEdBQWxGQSxHQUF3RixFQUFyRyxDQUNBUCxFQUFJNkMsZ0JBQUo3QyxDQUFxQk8sRUFBTzZCLG1CQUFQN0IsQ0FBMkI4QixVQUFoRHJDLEVBQTREMkMsSUFBU0wsQ0FBckV0QztBQUFxRXNDLFNBSHpFQTtBQVFSLFdBQUloQixLQUFBQSxDQUFhLENBQWpCO0FBQUEsVUFDSXdCLEtBQWMxQyxhQUFhMkMsS0FBYjNDLENBQW1CRSxDQUFuQkYsQ0FEbEI7QUFBQSxVQUVJSixJQUFNLElBQUlILE9BQU9tRCxjQUFYLEVBRlYsQ0FJQTlCLElBQWlCLGFBQUE7QUFDYkksYUFBQUEsQ0FBYSxDQUFiQSxFQUMyQixNQUF2QndCLEdBQVlHLE1BQVcsSUFDdkJqRCxFQUFJa0QsS0FBSmxELEVBRkpzQixFQUtBUixFQUFPLElBQUluQixVQUFVNEIsc0JBQWQsRUFBUFQsQ0FMQVE7QUFLcUJDLE9BTnpCTCxFQVNBdkIsVUFBVXdELFNBQVZ4RCxDQUFvQnlELE1BQXBCekQsQ0FBMkIwRDtBQUFBQSxlQUFrQixJQUFJekMsT0FBSjtBQUFBLDZFQUFZdUIsaUJBQUFBLENBQUFBO0FBQUFBO0FBQUFBO0FBQUFBO0FBQUFBO0FBQ3JESixzQkFBU3VCLFFBQVR2QixHQUFvQixVQUFVL0IsQ0FBVixFQUFVQTtBQUMxQiwwQkFBSTJCLElBQVEsSUFBWixDQUN1QixNQUFuQjNCLEVBQUl1RCxVQUFlLEdBQ25CNUIsSUFBUSxJQUFJNkIsS0FBSixDQUFVLDZCQUFWLENBRFcsR0FDRCxDQUVieEQsRUFBSXlELE1BQUp6RCxHQUFhLEdBQWJBLElBQW9CQSxFQUFJeUQsTUFBSnpELElBQWMsR0FGckIsTUFHbEIyQixJQUFRLElBQUk2QixLQUFKLENBQVUsaURBQWlEeEQsRUFBSXlELE1BQS9ELENBSFUsQ0FEQyxFQU9sQm5DLE9BQ0RvQyxFQUFZTCxFQUFlLGFBQWZBLEVBQThCN0MsQ0FBOUI2QyxFQUFtQ3JELEVBQUl5RCxNQUF2Q0osQ0FBWkssR0FFQTFELElBQU1ELGlCQUFpQkMsQ0FBakJELENBRk4yRCxFQUlLL0IsSUFJRGIsRUFBT2QsQ0FBUGMsQ0FKQ2EsR0FDRGQsRUFBUWIsQ0FBUmEsQ0FMSjZDLEVBV0l6QyxLQUNBQSxFQUFTVSxDQUFUVixFQUFnQmpCLENBQWhCaUIsQ0FiSEssQ0FQa0IsRUF3QnZCbEIsYUFBYXVELEdBQWJ2RCxDQUFpQkUsQ0FBakJGLEVBQXNCdUIsQ0FBdEJ2QixFQUE2QkosQ0FBN0JJLENBeEJ1QjtBQXdCTUoscUJBMUJqQytCLEVBNkJBQSxFQUFTckIsSUFBVHFCLEdBQWdCckIsQ0E3QmhCcUIsRUE4QklBLEVBQVNyQixJQUFUcUIsSUFBaUJ4QixFQUFPcUQsZ0JBQXhCN0IsSUFDQXhCLEVBQU9xRCxnQkFBUHJELENBQXdCd0IsQ0FBeEJ4QixDQS9CSndCLEVBa0NBQSxFQUFTL0IsR0FBVCtCLEdBQWU7QUFBQSw2QkFDSi9CLENBREk7QUFBQSxxQkFsQ2YrQixFQXNDQWUsR0FBWXpCLEVBQVp5QixDQUFlLGNBQWZBLEVBQStCLFlBQUE7QUFDQSw0QkFBdkJBLEdBQVlHLE1BQVcsSUFBSzNCLEVBQUwsS0FDdkJvQyxLQUNBMUQsRUFBSWtELEtBQUpsRCxFQURBMEQsRUFHQTVDLEVBQU8sSUFBSW5CLFVBQVU0QixzQkFBZCxFQUFQVCxDQUp1QjtBQUlGUyxxQkFMN0J1QixDQXRDQWYsQ0FEcURJO0FBQUFBO0FBQUFBLDJCQWtEM0MwQixlQUFldEQsRUFBTzZCLG1CQUF0QnlCLENBbEQyQzFCOztBQUFBQTtBQUFBQTtBQUFBQTs7QUFBQUE7QUFBQUE7QUFBQUE7O0FBQUFBO0FBd0RyRHZDLHNCQUFFa0UsSUFBRmxFLENBQU9tQyxDQUFQbkM7QUF4RHFEdUM7QUFBQUE7QUFBQUE7QUFBQUE7QUFBQUE7QUFBQUE7QUFBQUEsV0FBWjs7QUFBQTtBQUFBO0FBQUE7QUFBQSxZQUFsQmtCO0FBQUFBLE9BQTNCMUQsQ0FUQXVCO0FBaUVXYTtBQUFBQSxHQWhJWixDQUFQO0FBb0pKLFVBQVM4QixjQUFULENBQXdCTyxDQUF4QixFQUF3QkE7QUFBQUE7O0FBQ3BCLFNBQU8sSUFBSXhELE9BQUo7QUFBQSx3RUFBWXVCLGtCQUFPdEIsQ0FBUHNCLEVBQWdCckIsQ0FBaEJxQjtBQUFBQTtBQUFBQTtBQUFBQTtBQUFBQTtBQUFBQTtBQUFBQSxvQkFFWGlDLEtBQWlCQSxFQUFjQyxNQUZwQmxDO0FBQUFBO0FBQUFBO0FBQUFBOztBQUlQbUMsZUFKT25DO0FBQUFBLG9GQUlJQTtBQUFBQTtBQUFBQTtBQUFBQTtBQUFBQTtBQUFBQTtBQUNQb0MsMkJBRE9wQyxHQUNJMUMsT0FBT3lFLFVBQVB6RSxDQUFrQixtQkFBbEJBLENBREowQztBQUFBQTtBQUFBQSxpQ0FFTzFDLE9BQU8wRSxTQUFQMUUsQ0FBaUI4RSxDQUFqQjlFLEVBQTJCMkUsRUFBY0MsTUFBekM1RSxFQUF5QzRFLEVBQXpDNUUsQ0FGUDBDOztBQUFBQTtBQUVQcUMsMkJBRk9yQztBQUFBQSw0REFRSjlCLGdCQUxLVixVQUFVVyxHQUFWWCxDQUFVVyxFQUNsQkUsS0FBS2dFLENBRGFsRSxFQUVsQkcsUUFBUSxLQUZVSCxFQUdsQkksTUFBTSxJQUhZSixFQUFWWCxDQUtMVSxFQUF1QmtFLENBQXZCbEUsRUFBaUNtRSxDQUFqQ25FLEVBQXdDLEtBQXhDQSxFQUErQyxJQUEvQ0EsRUFBcURaLE9BQU9nRixvQkFBUGhGLENBQTRCLFVBQUNrQyxDQUFELEVBQVFqQixDQUFSLEVBQVFBO0FBRTlFLHFDQUFWaUIsQ0FBVSxJQUNWWSxhQUFhbUMsT0FBYm5DLENBQXFCNkIsRUFBYzNCLFVBQW5DRixFQUErQzdCLEVBQUtpRSxXQUFMakUsQ0FBaUJrRSxLQUFoRXJDLEdBQ0ExQixHQUZVLElBS1ZDLEVBQU9hLENBQVBiLENBTFU7QUFLSGEsMkJBUDZDbEMsQ0FBckRZLENBUkk4Qjs7QUFBQUE7QUFBQUE7QUFBQUE7QUFBQUE7QUFBQUE7QUFBQUE7QUFBQUEsaUJBSkpBOztBQUFBQTtBQUFBQTtBQUFBQTtBQUFBQSxtQkF3QlB5QyxDQXhCT3pDLEdBd0JDSSxhQUFhQyxPQUFiRCxDQUFxQjZCLEVBQWMzQixVQUFuQ0YsQ0F4QkRKOztBQUFBQSxtQkF5QlB5QyxDQXpCT3pDO0FBQUFBO0FBQUFBO0FBQUFBOztBQTBCSDBDLGVBMUJHMUMsR0EwQk8yQyxXQUFXRixDQUFYRSxDQTFCUDNDLEVBNEJINEMsQ0E1Qkc1QyxHQTRCWTZDLEtBQUtDLEdBQUxELEtBQWEsR0E1QnpCN0M7O0FBQUFBLG9CQTZCSDBDLEtBQVdBLEVBQVFLLEdBQVJMLEdBQWNFLENBN0J0QjVDO0FBQUFBO0FBQUFBO0FBQUFBOztBQUFBQTtBQUFBQSxxQkErQkdtQyxHQS9CSG5DOztBQUFBQTtBQUFBQTtBQUFBQTs7QUFBQUE7QUFrQ0h0QixpQkFsQ0dzQjs7QUFBQUE7QUFBQUE7QUFBQUE7O0FBQUFBO0FBQUFBO0FBQUFBLHFCQXNDRG1DLEdBdENDbkM7O0FBQUFBO0FBQUFBO0FBQUFBOztBQUFBQTtBQXlDWHRCO0FBekNXc0I7QUFBQUE7QUFBQUE7QUFBQUE7QUFBQUE7QUFBQUE7QUFBQUEsS0FBWjs7QUFBQTtBQUFBO0FBQUE7QUFBQSxNQUFQO0FBcktKLEtBYUkvQixZQWJKO0FBQUEsSUFtTkkrRSxZQW5OSjtBQUFBLElBQUkxRixTQUFTQyxRQUFRLGFBQVJBLENBQWI7QUFBQSxJQUNJQyxZQUFZRCxRQUFRLGlCQUFSQSxDQURoQjtBQUFBLElBRUlFLElBQXVCLGVBQUEsT0FBWEMsTUFBVyxHQUFjQSxPQUFlLE1BQTdCLEdBQW1ELGVBQUEsT0FBWEMsTUFBVyxHQUFjQSxPQUFlLE1BQTdCLEdBQWlDLElBRi9HO0FBQUEsSUFzSklpRTtBQUFBQSxzRUFBVTVCLGtCQUFnQjVCLENBQWhCNEIsRUFBd0IxQixDQUF4QjBCLEVBQWdDNkIsQ0FBaEM3QixFQUFzQzhCLENBQXRDOUIsRUFBa0R6QixDQUFsRHlCLEVBQXdEeEIsQ0FBeER3QjtBQUFBQTtBQUFBQTtBQUFBQTtBQUFBQTtBQUFBQTtBQUNWNUIsZ0JBQVNkLE9BQU95RSxVQUFQekUsQ0FBa0JjLENBQWxCZCxDQUFUYyxDQURVNEI7QUFBQUEsbUJBR00xQyxPQUFPMEUsU0FBUDFFLENBQWlCYyxDQUFqQmQsRUFBeUJ1RSxDQUF6QnZFLEVBQStCd0UsQ0FBL0J4RSxDQUhOMEM7O0FBQUFBO0FBR04zQixhQUhNMkI7QUFBQUEsOENBV0g5QixnQkFOR1YsVUFBVVcsR0FBVlgsQ0FBVVcsRUFDaEJFLEtBQUtBLENBRFdGLEVBRWhCRyxRQUFRQSxDQUZRSCxFQUdoQkksTUFBTUEsQ0FIVUosRUFBVlgsQ0FNSFUsRUFBcUJFLENBQXJCRixFQUE2QkcsQ0FBN0JILEVBQWtDSSxDQUFsQ0osRUFBMENLLENBQTFDTCxFQUFnRE0sQ0FBaEROLENBWEc4Qjs7QUFBQUE7QUFBQUE7QUFBQUE7QUFBQUE7QUFBQUE7QUFBQUE7QUFBQUEsR0FBVjRCOztBQUFBQTtBQUFBQTtBQUFBQTtBQUFBQSxHQXRKSixDQXFOQUEsUUFBUXFCLEtBQVJyQjtBQUFBQSxzRUFBZ0I1QixrQkFBZ0I1QixDQUFoQjRCLEVBQXdCMUIsQ0FBeEIwQixFQUFnQzZCLENBQWhDN0IsRUFBc0M4QixDQUF0QzlCLEVBQWtEekIsQ0FBbER5QixFQUF3RHhCLENBQXhEd0IsRUFBcUZrRCxDQUFyRmxELEVBQThGbUQsQ0FBOUZuRCxFQUEwR29ELENBQTFHcEQ7QUFBQUE7O0FBQUFBO0FBQUFBO0FBQUFBO0FBQUFBO0FBQUFBO0FBQ1o1QixnQkFBU2QsT0FBT3lFLFVBQVB6RSxDQUFrQmMsQ0FBbEJkLENBQVRjLENBRFk0QjtBQUFBQSxtQkFHSTFDLE9BQU8wRSxTQUFQMUUsQ0FBaUJjLENBQWpCZCxFQUF5QnVFLENBQXpCdkUsRUFBK0J3RSxDQUEvQnhFLENBSEowQzs7QUFBQUE7QUFHUjNCLGFBSFEyQjtBQUFBQSw4Q0FLTCxJQUFJdkIsT0FBSjtBQUFBLGtGQUFZdUIsa0JBQU90QixDQUFQc0IsRUFBZ0JyQixDQUFoQnFCO0FBQUFBOztBQUFBQTtBQUFBQTtBQUFBQTtBQUFBQTtBQUNYN0IseUJBRFc2QixHQUNMeEMsVUFBVVcsR0FBVlgsQ0FBVVcsRUFDaEJFLEtBQUtBLENBRFdGLEVBRWhCRyxRQUFRQSxDQUZRSCxFQUdoQkksTUFBTUEsQ0FIVUosRUFJaEJpRixVQUFVQSxDQUpNakYsRUFBVlgsQ0FES3dDO0FBUVZnRCx5Q0FDREEsZUFBZXhGLFVBQVV5RixLQUFWekYsQ0FBZ0I2RixXQUFoQjdGLEVBRGR3RixFQUlEbEUsQ0FaV2tCLEdBWUEsSUFaQUEsRUFhWGpCLENBYldpQixHQWFNLElBYk5BLEVBY1hoQixDQWRXZ0IsR0FjTixJQWRNQTs7QUFBQUEsOEJBZ0I0QixjQUFBLE9BQWhDeEIsQ0FBZ0MsR0FDdkNNLElBQVdOLENBRDRCLEdBR2xDQSxhQUF1Q2hCLFVBQVV5QixpQkFBakRULElBQWlEUyxDQUN0REQsSUFBS1IsQ0FEaURTLEVBRW5EQyxFQUZtREQsQ0FFaEQsVUFGZ0RBLEVBRXBDLFlBQUE7QUFDVkYsK0JBQ0FBLEdBREFBO0FBQ0FBLHlCQUo4Q0UsQ0FIZixFQVl2Q0QsS0FBTUEsRUFBR0csVUE1QkVhO0FBQUFBO0FBQUFBO0FBQUFBOztBQTZCWHJCLDBCQUFPLElBQUluQixVQUFVNEIsc0JBQWQsRUFBUFQsRUE3QldxQjtBQUFBQTs7QUFBQUE7QUFBQUEsNkJBaUNYZ0QsYUFBYTNELE1BQWIyRCxDQUFvQjdFLENBQXBCNkUsQ0FqQ1doRDtBQUFBQTtBQUFBQTtBQUFBQTs7QUFrQ1BzRCwwQkFsQ090RCxHQWtDTWdELGFBQWFPLEdBQWJQLENBQWlCN0UsQ0FBakI2RSxDQWxDTmhELEVBb0NQd0QsR0FwQ094RCxHQW9DTXhDLFVBQVVpRyxRQUFWakcsQ0FBbUIsWUFBQTtBQUNoQ2tCLDRCQUFRNEUsRUFBUjVFLEdBRUlJLEtBQ0FBLEVBQVNXLElBQVRYLENBQWNZLElBQWRaLEVBQW9CLElBQXBCQSxFQUEwQndFLEVBQTFCeEUsQ0FISko7QUFHOEI0RSx5QkFKakI5RixDQXBDTndDO0FBNENYakIsNEJBQWlCLGFBQUE7QUFDYnZCLG9DQUFVa0csYUFBVmxHLENBQXdCZ0csR0FBeEJoRyxHQUVBbUIsRUFBTyxJQUFJbkIsVUFBVTRCLHNCQUFkLEVBQVBULENBRkFuQjtBQUVxQjRCLHlCQUh6QkwsQ0E1Q1dpQjtBQUFBQTs7QUFBQUE7QUFBQUEsOEJBbURJLFFBQVhrRCxDQW5ET2xEO0FBQUFBO0FBQUFBO0FBQUFBOztBQW9EUGtELDBCQUFRSyxHQUFSTCxDQUFZL0UsQ0FBWitFO0FBQUFBLDhGQUFpQmxELGtCQUFBQSxDQUFBQTtBQUFBQTs7QUFBQUE7QUFBQUE7QUFBQUE7QUFBQUE7QUFBQUEsMENBQ0ssUUFBZDJELENBRFMzRDtBQUFBQTtBQUFBQTtBQUFBQTs7QUFFTHdELHVDQUZLeEQsR0FFUXhDLFVBQVVpRyxRQUFWakcsQ0FBbUIsWUFBQTtBQUNoQ2tCLHdDQUFRaUYsQ0FBUmpGLEdBRUlJLEtBQ0FBLEVBQVNXLElBQVRYLENBQWNZLElBQWRaLEVBQW9CLElBQXBCQSxFQUEwQjZFLENBQTFCN0UsQ0FISko7QUFHOEJpRixxQ0FKakJuRyxDQUZSd0M7QUFVVGpCLHdDQUFpQixhQUFBO0FBQ2J2QixnREFBVWtHLGFBQVZsRyxDQUF3QmdHLEdBQXhCaEcsR0FFQW1CLEVBQU8sSUFBSW5CLFVBQVU0QixzQkFBZCxFQUFQVCxDQUZBbkI7QUFFcUI0QixxQ0FIekJMLENBVlNpQjtBQUFBQTs7QUFBQUE7QUFBQUE7QUFBQUE7QUFBQUEsMkNBa0JnQjlCLGdCQUFnQkMsQ0FBaEJELEVBQXFCRSxDQUFyQkYsRUFBNkJHLENBQTdCSCxFQUFrQ0ksQ0FBbENKLEVBQTBDSyxDQUExQ0wsRUFBZ0RNLENBQWhETixDQWxCaEI4Qjs7QUFBQUE7QUFrQkQ0RCxzQ0FsQkM1RDtBQW9CTGdELGlEQUFhYSxHQUFiYixDQUFpQjdFLENBQWpCNkUsRUFBc0JZLEVBQXRCWixHQUNBRSxFQUFRVyxHQUFSWCxDQUFZL0UsQ0FBWitFLEVBQWlCVSxFQUFqQlYsRUFBMkJDLENBQTNCRCxDQURBRixFQUdBdEUsRUFBUWtGLEVBQVJsRixDQUhBc0UsQ0FwQktoRDtBQUFBQTs7QUFBQUE7QUFBQUE7QUFBQUE7QUEwQkxyQjtBQTFCS3FCO0FBQUFBO0FBQUFBO0FBQUFBO0FBQUFBO0FBQUFBO0FBQUFBLDJCQUFqQmtEOztBQUFBQTtBQUFBQTtBQUFBQTtBQUFBQSw2QkFwRE9sRDtBQUFBQTs7QUFBQUE7QUFBQUE7QUFBQUE7QUFBQUEsK0JBcUZrQjlCLGdCQUFnQkMsQ0FBaEJELEVBQXFCRSxDQUFyQkYsRUFBNkJHLENBQTdCSCxFQUFrQ0ksQ0FBbENKLEVBQTBDSyxDQUExQ0wsRUFBZ0RNLENBQWhETixDQXJGbEI4Qjs7QUFBQUE7QUFxRkM0RCwyQkFyRkQ1RDtBQXVGSGdELHFDQUFhYSxHQUFiYixDQUFpQjdFLENBQWpCNkUsRUFBc0JZLEdBQXRCWixHQUNlLFFBQVhFLENBQVcsSUFDWEEsRUFBUVcsR0FBUlgsQ0FBWS9FLENBQVorRSxFQUFpQlUsR0FBakJWLEVBQTJCQyxDQUEzQkQsQ0FGSkYsRUFLQXRFLEVBQVFrRixHQUFSbEYsQ0FMQXNFLENBdkZHaEQ7QUFBQUE7O0FBQUFBO0FBQUFBO0FBQUFBO0FBK0ZIckI7QUEvRkdxQjtBQUFBQTtBQUFBQTtBQUFBQTtBQUFBQTtBQUFBQTtBQUFBQSxlQUFaOztBQUFBO0FBQUE7QUFBQTtBQUFBLGdCQUxLQTs7QUFBQUE7QUFBQUE7QUFBQUE7QUFBQUE7QUFBQUE7QUFBQUE7QUFBQUEsR0FBaEI0Qjs7QUFBQUE7QUFBQUE7QUFBQUE7QUFBQUEsS0EyR0FrQyxPQUFPQyxPQUFQRCxHQUFpQmxDLE9BM0dqQkEifQ==